import { createAsyncThunk } from '@reduxjs/toolkit';
import { buildSalesforceParamsQuery } from '../../utils/methods';
import request from '../../modules/Request/request';

export const getSiteConfiguration = createAsyncThunk(
  'getSiteConfiguration',
  async (object, { rejectWithValue }) => {
    const finalQuery = buildSalesforceParamsQuery({}, object);
    const response = await request('/site-config', { method: 'GET', query: finalQuery });
    if (response.success) return response.data;
    const error = response.error && response.error.message
      ? response.error.message
      : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);

export const saveSiteConfiguration = createAsyncThunk(
  'saveSiteConfiguration',
  async (object, { rejectWithValue }) => {
    const response = await request('/site-config', { method: 'POST', body: object });
    if (response.success) {
      return response.data;
    }
    const error = response.error && response.error.message
      ? response.error.message
      : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);
